/** @module app.demo */

import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';
import { DemoModule } from 'app/demo/module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(DemoModule.registrationKey, DemoModule);

    config.globalResources([
        // value-converters
        PLATFORM.moduleName('./value-converters/code-converters'),

        // components
        PLATFORM.moduleName('./components/code-example')

    ]);
}

